import { FC } from 'react';
import styled from 'styled-components';
import { StepItemResponse } from '@/shared/api';
import { useThemeContext, themeConfig } from '@/shared/theme';
import { Row } from '@/shared/ui';

type Props = {
  index: number;
  step: StepItemResponse;
  selectedStepId?: string;
  onStepSelect: (id: string) => void;
};

export const StepItem: FC<Props> = ({
  step,
  index,
  onStepSelect,
  selectedStepId,
}) => {
  const { theme } = useThemeContext();

  const handleStepSelect = () => {
    if (step.visibilityType === 'Visible') {
      onStepSelect(step?.id!);
    }
  };

  return (
    <Step
      onClick={handleStepSelect}
      style={{
        background:
          selectedStepId === step?.id
            ? themeConfig[theme].colors.layoutOverlayBg
            : 'transparent',
        borderBottom: `1px solid ${themeConfig[theme].colors.border}`,
        opacity: step.visibilityType === 'Visible' ? 1 : 0.65,
        pointerEvents: step.visibilityType === 'Visible' ? 'all' : 'none',
      }}
    >
      <Row>
        <StepNumber
          style={{
            color:
              theme === 'light'
                ? themeConfig[theme].colors.text
                : themeConfig[theme].colors.bgBase,
          }}
        >
          #{index + 1}
        </StepNumber>
        {step?.title}
      </Row>
    </Step>
  );
};

const Step = styled.div`
  padding: 15px 5px 15px 15px;
  width: 100%;
  display: flex;
  gap: 10px;
  font-size: 12px;
  align-items: center;
  height: 50px;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
`;

const StepNumber = styled.div`
  font-family: 'Inter', sans-serif !important;
  background: #ffed66;
  padding: 5px;
  border-radius: 5px;
  font-weight: 500;
  font-size: 9px;
`;
